export default {
  urlApi: process.env.VUE_APP_URL_API,
  getConfig: (method, url, data) => getConfig(method, url, data)
};

const getConfig = (method, url, data) => {
  let configAux
  if (!data) {
    configAux = {
      url: `${process.env.VUE_APP_URL_API}${url}`,
      method,
    }
  } else {
    configAux = {
      url: `${process.env.VUE_APP_URL_API}${url}`,
      method,
      data
    }
  }
  return configAux
}
